import "./CustomTitle.scss"
import React from "react"


const Title = ({children, textDecoration, justifyContent, fontSize, ...props}) => {
  return (
    <div className={`title-container ${justifyContent ? `title-justifyContent-${justifyContent}` : ''}`} {...props}>
        <p className={`font-size-${fontSize || "lg"} title ${textDecoration ? `title-${textDecoration}` : ''}`}>
            {children}
        </p>
    </div>
  )
}

export default Title
